<div class="signature">
  <div class="signature__preview">
    <div class="d-flex align-items-center gap-10">
      <label class="text--md">Signature</label>

      <app-icon-feather *ngIf="!isModalVisible$.value && isSignExist" icon="check-circle"></app-icon-feather>

      <div class="ml-auto d-inline-flex gap-10">
        <app-icon icon="i-9" fill="#528BB0" tooltipPosition="left" pTooltip="Scan"></app-icon>
        <app-icon icon="i-15" fill="#528BB0" tooltipPosition="left" pTooltip="Voice input"></app-icon>
        <app-icon icon="i-42" fill="#528BB0" tooltipPosition="left" pTooltip="Manual input"></app-icon>
        <app-icon icon="i-26" fill="#528BB0"></app-icon>
      </div>
    </div>
    <div class="box"
         (click)="isModalVisible$.next(true)"
    >
      <ng-container [ngSwitch]="!isModalVisible$.value">

        <ng-container *ngSwitchCase="!!signature?.text">
          <input [value]="signature.text">
        </ng-container>

        <ng-container *ngSwitchCase="!!signature?.file">
          <img [src]="signature.file">
        </ng-container>

      </ng-container>

    </div>
  </div>

  <div class="signature__modal">
    <p-dialog
      [style]="{ width: '100vw', maxWidth: '630px' }"
      [modal]="true"
      [closable]="true"
      [visible]="isModalVisible$.value"
      (visibleChange)="isModalVisible$.next($event)"
      header=" "
      appendTo="body"
      transitionOptions="0ms"
    >
      <div class="signature__wrapper">
        <h3>Signature</h3>
        <div class="signature__tab-panel" *ngIf="isModalVisible$.value">
          <p-tabView (onChange)="onTabChange($event)">
            <p-tabPanel [cache]="false">
              <ng-template pTemplate="header">
                <app-icon icon="i-1"></app-icon>
                <span class="ml-1">Draw</span>
              </ng-template>
              <div class="ml-3">
                <p>Draw</p>
                <div class="canvas-wrapper">
                  <canvas id="signature-pad"></canvas>
                </div>

                <div class="d-flex mt-5 gap-20 justify-content-end">
                  <button pButton
                          class="p-button-outlined"
                          label="CLEAR"
                          (click)="clear()"
                  ></button>
                  <button pButton
                          label="SAVE"
                          (click)="save()"
                  ></button>
                </div>
              </div>
            </p-tabPanel>

            <p-tabPanel [cache]="false">
              <ng-template pTemplate="header">
                <app-icon icon="i-1"></app-icon>
                <span class="ml-1">Type</span>
              </ng-template>
              <div class="container">
                <div class="row">
                  <div class="col-12">
                    <div class="p-field">
                      <div class="p-field__title">
                        <label class="text--md">Type</label>

                        <div class="ml-auto">
                          <app-icon icon="i-9" fill="#528BB0" tooltipPosition="left" pTooltip="Scan"></app-icon>
                          <app-icon icon="i-15" fill="#528BB0" tooltipPosition="left" pTooltip="Voice input"></app-icon>
                          <app-icon icon="i-42" fill="#528BB0" tooltipPosition="left" pTooltip="Manual input"></app-icon>
                          <app-icon icon="i-26" fill="#528BB0"></app-icon>
                        </div>
                      </div>

                      <input
                        pInputText
                        type="text"
                        [(ngModel)]="signature.text"
                      />
                    </div>

                    <div class="d-flex mt-5 gap-20 justify-content-end">
                      <button pButton
                              label="SAVE"
                              (click)="save()"
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
            </p-tabPanel>

            <p-tabPanel
              [cache]="false"
              disabled="true"
            >
              <ng-template pTemplate="header">
                <app-icon icon="i-1"></app-icon>
                <span class="ml-1">Biometrics</span>
              </ng-template>
              <div class="container">
                <div class="row">
                  <div class="col-12">
                    <p>Biometrics</p>
                  </div>
                </div>
              </div>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </p-dialog>
  </div>
</div>

